export { DateRangePickerLabelPipe, getDateRangePickerLabel } from './date-range-picker-label.pipe';
export { DateRangePickerComponent, getDateRangeValueDates } from './date-range-picker.component';
